import { render } from "./CardsComponent.vue?vue&type=template&id=71398e66"
import script from "./CardsComponent.vue?vue&type=script&lang=js"
export * from "./CardsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__